import  {useEffect, useState} from "react";
import {getRelativeTime} from "../../util/CommonUtils";

export const useTimeLeft = (startTime) => {
    const [leftTime, setLeftTime] = useState('');
    useEffect(() => {
        setLeftTime(getRelativeTime(startTime, ''));
        const remainingSecond = setInterval(() =>
            setLeftTime(getRelativeTime(startTime, '')), 1000);
        return () => clearInterval(remainingSecond);
    }, [startTime]);
    return leftTime;
}


// WEBPACK FOOTER //
// ./src/components/scrub/TimeLeft.js